import { render } from "./FilterSubstitutionModal.vue?vue&type=template&id=d356f8c8"
import script from "./FilterSubstitutionModal.vue?vue&type=script&lang=js"
export * from "./FilterSubstitutionModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__